module.exports = __webpack_public_path__ + "static/media/spectrum.90cdf986.png";